export default __webpack_public_path__ + "static/media/photo15.5ec9d83c.jpeg";